module.exports = __webpack_public_path__ + "img/mge_logo_en.dbcde847.svg";